{
  "(optional)": "(facoltativo)",
  "(required)": "(obbligatorio)"
}
